import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DialogComponent} from "../shared/dialog/dialog.component";
const incr = 5;

@Component({
  selector: 'app-show-progress',
  templateUrl: './show-progress.component.html',
  styleUrls: ['./show-progress.component.css']
})
export class ShowProgressComponent implements OnInit {

  @Input() showProgress = false;
  @Output() flag = new EventEmitter<any>();
  progressMessage: any;
  progress = 0;
  BlockList = {
    '1': 0,
    '2': 25,
    '3': 50,
    '4': 75,
    '5': 100
  };
  constructor(private dlg: DialogComponent) { }
  @Input() Blocks = [];
  ngOnInit() {
    const blockLength = this.Blocks.length;
    const blockStart = this.BlockList[this.Blocks[0]];
    const blockEnd = this.BlockList[this.Blocks[blockLength-1]];
    this.progress = blockStart;
    setInterval(() => this.manageProgress(blockEnd), 1000);
  }

  manageProgress(blockEnd) {
    if (this.progress >= blockEnd) {
    } else {
      this.progress = this.progress + incr;
    }
    if (blockEnd === 50 && this.progress > 45 && this.progress <= 50) {
      this.flag.emit();
    }
    if (blockEnd === 75 && this.progress > 70 && this.progress <= 75) {
      this.flag.emit();
    }
    if (this.progress <= 35) {
      this.progressMessage = 'Setting Up API';
    } else if (this.progress > 35 && this.progress <= 70) {
      this.progressMessage = 'Setting Up Database';
      /*} else if (this.progress > 70 && this.progress <= 98) {
          this.progressMessage = 'Creating dedicated File storage for your account';*/
    } else if (this.progress > 70 && this.progress < 100) {
      this.progressMessage = 'Deploying into Cloud';
    } else if (this.progress === 100) {
      this.flag.emit();
    }
  }
  checkBlock(block: number) {
    const blocks = this.Blocks;
    return blocks.includes(block);
  }
}
